import { render, staticRenderFns } from "./RVR.vue?vue&type=template&id=3081cadf&"
import script from "./RVR.vue?vue&type=script&lang=js&"
export * from "./RVR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports